export default __webpack_public_path__ + "static/media/SavePaper.826d57dc.jpg";